import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-disclaimer-modal',
  templateUrl: './disclaimer-modal.component.html',
  styleUrls: ['./disclaimer-modal.component.css']
})
export class DisclaimerModalComponent {
  @Input() showModal: boolean = false;
  @Input() disclaimerText: string = 'Please ensure that the linked entities belong to the correct hierarchy';
  @Input() acknowledgmentText: string = 'I acknowledge the impact of linking and pricing inheritance from master merchant including Reseller Pricing.';
  @Input() modalTitle: string = 'Important Notice';
  @Input() confirmButtonText: string = 'Confirm';
  @Input() cancelButtonText: string = 'Cancel';
  
  @Output() modalClose = new EventEmitter<void>();
  @Output() modalConfirm = new EventEmitter<void>();
  
  acknowledgmentChecked: boolean = false;

  onClose(): void {
    this.acknowledgmentChecked = false;
    this.modalClose.emit();
  }

  onConfirm(): void {
    if (!this.acknowledgmentChecked) {
      return;
    }
    this.modalConfirm.emit();
    this.acknowledgmentChecked = false;
  }

  onModalClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('modal') || target.classList.contains('modal-dialog')) {
      this.onClose();
    }
  }
}

